import { render, staticRenderFns } from "./ServiceLit.vue?vue&type=template&id=65c7c36b&scoped=true&"
import script from "./ServiceLit.vue?vue&type=script&lang=js&"
export * from "./ServiceLit.vue?vue&type=script&lang=js&"
import style0 from "./ServiceLit.vue?vue&type=style&index=0&id=65c7c36b&scoped=true&slang=scss&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c7c36b",
  null
  
)

export default component.exports